import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface SortByFilterProps {
  value?: string;
  onChange: (value: string) => void;
}

export const SortByFilter = ({ value, onChange }: SortByFilterProps) => {
  const { t } = useTranslation();

  const sortOptions = [
    { value: "date", label: t("contractorVisits.fields.date") },
    { value: "status", label: t("contractorVisits.fields.status") },
    { value: "store_name", label: t("contractorVisits.fields.store") },
    { value: "project_name", label: t("contractorVisits.fields.project") },
  ];

  return (
    <div className="space-y-2">
      <Label htmlFor="sort-filter">
        {t("contractorVisits.filter.sort.label")}
      </Label>
      <Select value={value || "date"} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue
            placeholder={t("contractorVisits.filter.sort.placeholder")}
          />
        </SelectTrigger>
        <SelectContent className="z-[60]">
          {sortOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
